export default "__VITE_ASSET__DNFfaFQt__"